import React, { useState, useCallback } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
// import InputBase from "@mui/material/InputBase";

import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../reduxStore/actions/auth";
// import { styled, alpha } from "@mui/material/styles";

import TNIBRO_LOGO from "../assets/stock_yaari_logo.png";
import RandomUser from "../assets/icons/male-user.png";

import styles from "./NavbarNEW.module.css";
import SearchBox from "../components/SearchBox";
import toast from "react-hot-toast";
import { axiosConfig } from "../axios/axiosConfig";
import { REFERRAL_DASHBOARD_ROLES, REFERRAL_ROLE_LABELS } from "../pages/referral-dashboard/referralRoles";

// {/* IMP: DISABLING FEW LINKS AS WEB APP IS NOT LIVE */}
const mainMenu = [
  { title: "Screener", linkto: "/screener" },
  { title: "Saved Scans", linkto: "/savedscan" },
  { title: "Options", linkto: "/nse-option-chain" },
  // { title: "Recommended Stocks", linkto: "/recommended-stocks?tab=nifty50" },
  // { title: "Chart", linkto: "/charts/" },
  // { title: "Dashboards", linkto: "/dashboards" },
  // { title: "Watchlist", linkto: "/watchlist" },
  { title: "Alerts", linkto: "/alerts" },
  { title: "Pricing", linkto: "/pricing" },
];

// const userOptions = [
//   { title: "Screener", linkto: "/screener" },
//   { title: "Logout", linkto: "/screener" },
// ];

// const Search = styled("div")(({ theme }) => ({
//   position: "relative",
//   borderRadius: theme.shape.borderRadius,
//   backgroundColor: alpha(theme.palette.common.white, 0.15),
//   "&:hover": {
//     backgroundColor: alpha(theme.palette.common.white, 0.25),
//   },
//   marginLeft: 0,
//   width: "100%",
//   [theme.breakpoints.up("sm")]: {
//     marginLeft: theme.spacing(1),
//     width: "auto",
//   },
// }));

// const SearchIconWrapper = styled("div")(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: "100%",
//   position: "absolute",
//   pointerEvents: "none",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// }));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   color: "inherit",
//   "& .MuiInputBase-input": {
//     border: "1px solid #ccc",
//     borderRadius: 4,
//     padding: theme.spacing(1, 1, 1, 0),
//     // vertical padding + font size from searchIcon
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create("width"),
//     width: "100%",
//     [theme.breakpoints.up("sm")]: {
//       width: "12ch",
//       "&:focus": {
//         width: "20ch",
//       },
//     },
//   },
// }));

function NavbarNEW({ isAuth: isAuthProp, userDetails: userDetailsProp, showSearchBox = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userState = useSelector((store) => store.auth);
  // Layouts pass isAuth from a module-level localStorage read, which is stale right after
  // login (no page reload). Fall back to the live redux auth state so the profile shows.
  const isAuth = !!isAuthProp || !!userState?.user;
  const userDetails = userDetailsProp || userState?.user?.userDetails;
  console.log("userDetails", userDetails);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  // Any referral_role (SuperAdmin → SubBroker) gets a link to the /referral dashboard,
  // on top of whatever their user_type already gives them.
  const referralRole = userDetails?.referral_role;
  const hasReferralDashboard = REFERRAL_DASHBOARD_ROLES.includes(referralRole);
  const referralDashboardLabel = `${REFERRAL_ROLE_LABELS[referralRole] || referralRole} Dashboard`;
  // const [anchorElAdmin, setAnchorElAdmin] = useState(null);

  // const searchStocksQuery = useQuery({
  //   queryKey: ["search-stocks"],
  //   queryFn: () => handleSearch(searchInput),
  //   onSuccess: (data) => {
  //     console.log(data.response);

  //     setSearchResultsList(data.response);
  //   },
  //   onError: (error) => {
  //     console.log('search stocks error: ', error)
  //     toast.error(error?.response?.data?.response || "Something went wrong");
  //   },
  // })

  // NAV MENU & USER MENU FUNCTIONS
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  // const handleOpenAdminMenu = (event) => {
  //   setAnchorElAdmin(event.currentTarget);
  // };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  // const handleCloseAdminMenu = () => {
  //   setAnchorElAdmin(null);
  // };

  const logOut = useCallback(() => {
    dispatch(logout());
    setAnchorElUser(null);
    window.location.reload();
  }, [dispatch]);

  const handleLogOut = useCallback(async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      const user_id = userData?.response?.id || userData?.userDetails?.id;

      if (!user_id) {
        toast.error("User ID missing!");
        return;
      }

      // ✅ Logout API call
      const res = await axiosConfig({
        method: "post",
        url: "/enroll/user-logout",
        data: {
          user_id,
          device_id: "web-client",
        },
      });

      if (res.status === 200 || res.statusText === "OK") {
        toast.success("Logged out successfully!", {
          duration: 4000,
          position: "top-center",
        });
      }

      // ✅ Redux logout + cleanup
      dispatch(logout());
      localStorage.clear();
      setAnchorElUser(null);
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      toast.error(
        error.response?.data?.response || "Failed to logout. Please try again.",
        {
          duration: 4000,
          position: "top-center",
        }
      );
    }
  }, [dispatch, navigate]);

  // temp Array for top menu tags/chips
  const leftMenuTags = [
    { id: 1, label: "Cash", link: "/recommended-stocks?tab=cash" },
    { id: 2, label: "Nifty 50", link: "/recommended-stocks?tab=nifty50" },
    { id: 3, label: "mcx", link: "/recommended-stocks?tab=mcx" },
    { id: 4, label: "futures", link: "/recommended-stocks?tab=futures" },
    { id: 5, label: "Options", link: "/nse-option-chain" },
  ];

  const rightMenuTags = [
    { id: 1, label: "Support", link: "/", display: "inline-block" },
    { id: 2, label: "Premium", link: "/", display: "inline-block" },
    {
      id: 3,
      label: "Log In or Sign Up",
      link: "/login",
      display: userState?.isLoggedIn ? "none" : "inline-block",
    },
  ];

  const activeNavMenuStyles = {
    // backgroundColor: '#98FB98',
    borderBottom: "2px solid #339502",
    borderTop: "2px solid #339502",
    color: "white",
    // borderRadius: '4px'
  };

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1300,
        backgroundColor: "white",
      }}
    >
      <div className={styles.topBar}>
        <div className={styles.leftMenu}>
          {leftMenuTags.map((item) => {
            return (
              <Link key={item.id} to={item.link}>
                <span className={styles.leftMenuItem}>{item.label}</span>
              </Link>
            );
          })}
        </div>
        <div className={styles.rightMenu}>
          {rightMenuTags.map((item) => {
            return (
              <Link
                key={item.id}
                to={item.link}
                style={{ display: item.display }}
              >
                <span className={styles.rightMenuItem}>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>

      <AppBar
        position="static"
        // top={0}
        sx={{
          zIndex: 1201,
          backgroundColor: "rgb(253, 253,253)",
          color: "#333",
          boxShadow: "none",
          borderBottom: "1px solid #e2e9ee",
        }}
      >
        <Container maxWidth={false} disableGutters>
          <Toolbar disableGutters sx={{ px: "50px" }}>
            {/* Logo pinned left — width matches the sidebar (240px) */}
            <Link to="/home">
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  flexShrink: 0,
                }}
              >
                <img src={TNIBRO_LOGO} alt="Logo" width={120} />
              </Box>
            </Link>

           

            {/* <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            TNIBRO
          </Typography> */}

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {mainMenu.map((menu) => (
                  <MenuItem
                    key={menu.title}
                    onClick={handleCloseNavMenu}
                    sx={{
                      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                    }}
                  >
                    <Link to={menu.linkto}>
                      <Typography textAlign="center" textTransform="capitalize">
                        {menu.title}
                      </Typography>
                    </Link>
                  </MenuItem>
                ))}
                {hasReferralDashboard && (
                  <MenuItem onClick={handleCloseNavMenu}>
                    <Link to="/referral">
                      <Typography textAlign="center">{referralDashboardLabel}</Typography>
                    </Link>
                  </MenuItem>
                )}
              </Menu>
            </Box>
            {/* <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} /> */}

            <Box
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                alignItems: "center",
                gap: 1,
              }}
            >
              <Link to="/home">
                <img src={TNIBRO_LOGO} alt="Logo" width={120} />
              </Link>
        
            </Box>

            {/* <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            TNIBRO
          </Typography> */}
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {mainMenu.map((menu) => (
                <NavLink
                  to={menu.linkto}
                  className={styles.NavLink}
                  style={({ isActive }) =>
                    isActive ? activeNavMenuStyles : {}
                  }
                >
                  <span className={styles.navMenuItem}>{menu.title}</span>
                  {/* <Button
                  key={menu.title}
                  onClick={handleCloseNavMenu}
                  sx={{
                    my: 2,
                    color: "#333",
                    fontSize: "15px",
                    display: "block",
                    textTransform: "capitalize",
                    border: menu.title === "Chart" ? "1px solid" : "none",
                    "&:hover": { backgroundColor: "#eee" },
                  }}
                >
                  {menu.title}
                </Button> */}
                </NavLink>
              ))}

              {/* ADMIN BUTTON & OPTIONS HERE */}
              {userDetails?.user_type === "Admin" && (
                <Box
                  sx={{
                    display: "flex",
                  }}
                >
                  <Tooltip title="Super Admin Dashboard">
                    <Button
                      // onClick={handleOpenAdminMenu}
                      onClick={() => navigate("/admin/invoice-dashboard")}
                      sx={{
                        my: 2,
                        color: "##016551", display: "block", fontWeight: "bold", fontSize: "0.875rem",
                      }}
                    >
                      Admin
                    </Button>
                  </Tooltip>

                  <Tooltip title="Advisor Dashboard">
                    <Button
                      // onClick={handleOpenAdminMenu}
                      onClick={() => navigate("/advisor/advisory-form")}
                      sx={{
                        my: 2,
                        color: "#016551", display: "block", fontWeight: "bold", fontSize: "0.875rem",
                      }}
                    >
                      Advisor
                    </Button>
                  </Tooltip>

                  <Tooltip title="Marketing Dashboard">
                    <Button
                      onClick={() => navigate("/agent/invoice-dashboard")}
                      sx={{
                        my: 2,
                        color: "#016551", display: "block", fontWeight: "bold", fontSize: "0.875rem",
                      }}
                    >
                      Marketing
                    </Button>
                  </Tooltip>

                  <Tooltip title="Investor Dashboard">
                    <Button
                      onClick={() => navigate("/investor")}
                      sx={{
                        my: 2,
                        color: "#016551", display: "block", fontWeight: "bold", fontSize: "0.875rem",
                      }}
                    >
                      Investor
                    </Button>
                  </Tooltip>

                </Box>
              )}
              {(userDetails?.user_type === "Advisor" || userDetails?.user_type === "MasterAdvisor") && (
                <Tooltip title="Advisor Dashboard">
                  <Button
                    // onClick={handleOpenAdminMenu}
                    onClick={() => navigate("/advisor/advisory-form")}
                    sx={{
                      my: 2,
                      color: "#016551", display: "block", fontWeight: "bold", fontSize: "0.875rem",
                    }}
                  >
                    Advisor
                  </Button>
                </Tooltip>
              )}
              {userDetails?.user_type === "Marketing" && (
                <Tooltip title="Marketing Dashboard">
                  <Button
                    onClick={() => navigate("/agent/users")}
                    sx={{
                      my: 2,
                      color: "#016551", display: "block", fontWeight: "bold", fontSize: "0.875rem",
                    }}
                  >
                    Marketing
                  </Button>
                </Tooltip>
              )}
              {userDetails?.user_type === "Investor" && (
                <Tooltip title="Investor Dashboard">
                  <Button
                    onClick={() => navigate("/investor")}
                    sx={{
                      my: 2,
                      color: "#016551", display: "block", fontWeight: "bold", fontSize: "0.875rem",
                    }}
                  >
                    Investor
                  </Button>
                </Tooltip>
              )}

              {/* Referral dashboard link (SuperAdmin / ReferralAdmin / Broker / BDM / SubBroker) — kept last */}
              {hasReferralDashboard && (
                <NavLink
                  to="/referral"
                  className={`${styles.NavLink} ${styles.referralNavLink}`}
                  style={{ border: "none", borderRadius: 0 }}
                >
                  <span className={styles.navMenuItem} style={{ textTransform: "uppercase" }}>{referralDashboardLabel}</span>
                </NavLink>
              )}
              {/* MENU NOT NEEDED, MADE DASHBOARD FOR ADMIN */}
              {/* <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElAdmin}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElAdmin)}
              onClose={handleCloseAdminMenu}
            >
              {adminMenuOptions.map((menu) => (
                <Link to={menu.linkto}>
                  <MenuItem key={menu.title} onClick={handleCloseAdminMenu}>
                    <Typography textAlign="center">{menu.title}</Typography>
                  </MenuItem>
                </Link>
              ))}
            </Menu> */}
            </Box>

            {/* PROFILE ICON AND OPTIONS */}
            {isAuth ? (
              <Box sx={{ flexGrow: 0, }}>
                <Box
                  onClick={handleOpenUserMenu}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                    cursor: "pointer",
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: "50px",
                    pl: 0.5,
                    pr: 2,
                    py: 0.5,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                      borderColor: "#bbb",
                    },
                  }}
                >
                  <Avatar
                    sx={{ bgcolor: "#D1FAE5", width: 34, height: 34, border: "2px solid #016551" }}
                    alt="TNIBro"
                    src={RandomUser}
                  />
                  {userDetails && (
                    <Box sx={{ display: { xs: "none", sm: "flex" }, flexDirection: "column", lineHeight: 1.1 }}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 700,
                          color: "#1a1a1a",
                          letterSpacing: "0.3px",
                        }}
                      >
                        {userDetails.phoneno || userDetails.email}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "11px",
                          color: "#888",
                          fontWeight: 500,
                        }}
                      >
                        {userDetails.referral_role
                          ? `${userDetails.user_type} · ${userDetails.referral_role}`
                          : userDetails.user_type}
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {/* {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))} */}

                  {/* <MenuItem
                onClick={() => {
                  navigate("/profile");
                  setAnchorElUser(null);
                }}
              >
                Profile
              </MenuItem> */}
                  <MenuItem
                    onClick={() => {
                      setAnchorElUser(null);
                      navigate("/user-dashboard/profile");
                    }}
                  >
                    My Dashboard
                  </MenuItem>
                  <MenuItem onClick={handleLogOut}>
                    {isAuth ? "Logout" : "Login"}
                  </MenuItem>
                </Menu>
              </Box>
            ) : null}

          </Toolbar>
          {/* </Container> */}
        </Container>
      </AppBar>

      {/* SEARCH BOX */}
      {/* <SearchBox /> */}
      {/* <GlobalSearchBar /> */}
      {/* {showSearchBox ? (
        <SearchBox />
      ) : null} */}
    </Box>
  );
}
export default NavbarNEW;
